module.exports = __webpack_public_path__ + "static/img/礼标签.772e583b.png";